export function getCookie(name) {
    let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
    arr = document.cookie.match(reg)
    if (arr)
        return decodeURIComponent(arr[2])
    else
        return null
}

export function setCookie(name, value, expires) {
    let hostname = document.location.hostname
    let ipReg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
    if (!ipReg.test(hostname)) {
        let items = hostname.split('.')
        if (items.length > 2) {
            hostname = document.location.hostname.substring(document.location.hostname.indexOf('.') + 1)
        }
    }
    let cookie = `${name}=${encodeURIComponent(value)};domain=${hostname};path=/`
    if (expires) {
        if (typeof expires === 'number') {
            const expiresDate = new Date()
            expiresDate.setTime(expiresDate.getTime() + expires)
            expires = expiresDate
        }
        cookie += `;expires=${expires.toGMTString()}`
    }
    document.cookie = cookie
}

export function delCookie(name, local) {
    setCookie(name, '', -1)
    // 同步删除localstorage
    if(local){
        localStorage.setItem(name, '')
    }
}



// WEBPACK FOOTER //
// ./src/util/cookie.js